/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetLatestLocationVisitedRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {GetLatestLocationVisitedResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const getLatestLocationVisited = (request: GetLatestLocationVisitedRequest, options?: CashRequestOptions) => post<GetLatestLocationVisitedRequest, GetLatestLocationVisitedResponse>("/2.0/cash/get-latest-location-visited", request, {...options, rejectOnError: true })